export default class ReviewsController {
    static setup() {
        // Update the header text when you click a tab
        document.body.addEventListener('click', (e) => {
            const tab = e.target.closest('.yotpo-nav-tab');

            if (!tab) return;
            const headerEls = document.querySelectorAll('.review-question-header');
            const txt = tab.querySelector('span')?.textContent ?? '';

            headerEls.forEach((el) => {
                el.textContent = txt;
            });
        });

        // Wait for the “active” class on the nav tabs to change,
        // then prepend a header span once.
        const initialCount = document.querySelectorAll('li.yotpo-nav-tab.yotpo-active').length;

        function waitForNavTabs() {
            setTimeout(() => {
                const currentCount = document.querySelectorAll('li.yotpo-nav-tab.yotpo-active').length;

                if (currentCount === initialCount) {
                    // not changed yet—check again
                    waitForNavTabs();
                } else {
                    // once it changes, prepend our header
                    const container = document.querySelector('div.bottom-line-items');
                    const activeSpan = document.querySelector('li.yotpo-nav-tab.yotpo-active span');

                    if (container && activeSpan) {
                        const span = document.createElement('span');

                        span.className = 'review-question-header';
                        span.textContent = activeSpan.textContent;
                        container.insertBefore(span, container.firstChild);
                    }
                }
            }, 50);
        }

        waitForNavTabs();
    }
}
